import { render, staticRenderFns } from "./detailsPage.vue?vue&type=template&id=75aa773b&scoped=true&"
import script from "./detailsPage.vue?vue&type=script&lang=js&"
export * from "./detailsPage.vue?vue&type=script&lang=js&"
import style0 from "./detailsPage.vue?vue&type=style&index=0&id=75aa773b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa773b",
  null
  
)

export default component.exports